const initQuest = {
  questUnits: [],
  questMissions: [],
  questCheckpoints: [],
  questBadges: [],
  selectedUnitId: "",
  selectedMissionId: "",
  isFormLoading: false,
};

const toSafeArray = (val: any) => (Array.isArray(val) ? val : []);

export const questReducer = (state = initQuest, action: any) => {
  if (action.type === "SET_QUEST_UNITS") {
    return { ...state, questUnits: toSafeArray(action.value) };
  }
  if (action.type === "SET_QUEST_MISSIONS") {
    return { ...state, questMissions: toSafeArray(action.value) };
  }
  if (action.type === "SET_QUEST_CHECKPOINTS") {
    return { ...state, questCheckpoints: toSafeArray(action.value) };
  }
  if (action.type === "SET_QUEST_BADGES") {
    return { ...state, questBadges: toSafeArray(action.value) };
  }
  if (action.type === "SET_QUEST_SELECTED_UNIT") {
    return { ...state, selectedUnitId: action.value };
  }
  if (action.type === "SET_QUEST_SELECTED_MISSION") {
    return { ...state, selectedMissionId: action.value };
  }
  if (action.type === "SET_QUEST_FORM_LOADING") {
    return { ...state, isFormLoading: action.value };
  }
  return state;
};
